module.exports = __webpack_public_path__ + "img/sand-rock-medium-12.64257502.png";